var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_755_15388)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_15388)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#912018"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_755_15388)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8525,
    cy: 15.0595,
    rx: 24.1463,
    ry: 23.7024,
    fill: "#F97066"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_755_15388)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.6317,
    cy: 11.7855,
    rx: 14.7561,
    ry: 14.4048,
    fill: "#FDA29B"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter3_f_755_15388)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.2504,
    cy: 3.73998,
    rx: 6.2504,
    ry: 3.73998,
    transform: "matrix(0.981993 -0.188915 0.196258 0.980552 20.1201 37.7184)",
    fill: "#F04438"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.72 8.76L24.88 9.8L12.84 25.8L13.16 24.68H25.76C26.8533 24.68 27.5467 24.5467 27.84 24.28C28.1333 23.9867 28.3333 23.4933 28.44 22.8H29.2C29.2 24.32 29.2133 25.4933 29.24 26.32C29.2667 27.12 29.3067 27.8533 29.36 28.52C29.1733 28.4667 28.84 28.44 28.36 28.44C27.88 28.4133 27.32 28.3867 26.68 28.36C26.04 28.3333 25.3733 28.32 24.68 28.32C24.0133 28.32 23.3733 28.32 22.76 28.32H10.44V27.48L24.72 8.76ZM25.36 8.76V35.64H21.2V13.96L24.72 8.76H25.36Z",
    fill: "#7A271A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_755_15388",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.406349,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_755_15388"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.176471 0 0 0 0 0.12549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_755_15388"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_755_15388",
    x: -20.2575,
    y: -24.6066,
    width: 80.2202,
    height: 79.3322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98186,
    result: "effect1_foregroundBlur_755_15388"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_755_15388",
    x: -14.0881,
    y: -18.583,
    width: 61.4396,
    height: 60.7369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98186,
    result: "effect1_foregroundBlur_755_15388"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_755_15388",
    x: 13.1472,
    y: 28.6886,
    width: 27.6895,
    height: 23.0326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.83129,
    result: "effect1_foregroundBlur_755_15388"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_15388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3);
export default __webpack_public_path__ + "static/media/number3.b270939a7a3b7289a157b1c663e3d580.svg";
export { ForwardRef as ReactComponent };